import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import SearchForm from './components/SearchForm';;

const SearchClinicHistory = ({ data }) => {
  return (<Container className="dashboard">
    <Row>
      <Col md={12}>
        <div className="title-general-section-icon-arrow-back">
          <h3>Historias Clínicas</h3>
        </div>
      </Col>
    </Row>
    <Row>
      <SearchForm data={data} />
    </Row>
  </Container>)
};

export default SearchClinicHistory;